import script from "./TransactionFeeNote.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransactionFeeNote.vue?vue&type=script&lang=ts&setup=true"

import "./TransactionFeeNote.vue?vue&type=style&index=0&id=5d53231a&lang=scss"

const __exports__ = script;

export default __exports__